import React, { Component } from "react"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"

export default class CostingModule extends Component {
  state = {
    _id: "",
    costing: [],
    STATUS: [],
    assignedToList: [],
    disabled: false,
    costingComments: ""
  }

  componentWillMount() {
    const { _id, costingComments, costingProcess, disabled, STATUS } = this.props
    this.setState({
      _id,
      costingComments,
      costingProcess,
      disabled, STATUS
    })
  }

  componentWillReceiveProps(nextProps) {
    const { _id, costingComments, costingProcess, disabled, STATUS } = nextProps
    this.setState({
      _id,
      costingComments,
      costingProcess,
      disabled, STATUS
    })
  }

  render() {
    const { STATUS } = this.state
    const { permissions } = this.props
    return (
      <div
        class="card-filter meeting-min-con"
        id="costing"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12">
          <div class="col-md-12">
            <ModuleHeader
              header={"Costing"}
              onClick={this.onOpenModal}
              _id={this.state._id}
              process={this.state.costingProcess}
              disabled={this.state.disabled}
              updateModulesMain={this.props.updateModulesMain}
              moduleName={"costing"}
              statusList={STATUS}
            />
          </div>
          <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
            <form name="costingForm" style={{ width: "100%" }}>
              <div class="wash-container">
                <div class="col-md-12 no-padding">
                  <div class="col-md-12 no-padding">
                    {/* <div class="col-md-2 step-one">
                        <div class="form-group">
                          <label for="ref-no">Assigned To</label>
                          <br />
                          <div class="custom-async-select">
                            <Async
                                name="assignedTo"
                                value={value.assignedTo}
                                // onInputChange={this.getFabricNumber}
                                // onChange={(value) => this.props.getFabricInfo(value,index)}
                                placeholder="Find AssignedTo"
                                options={this.state.assignedToList}
                                disabled = {true}
                            />
                        </div>
                        </div>
                      </div> */}
                    {/* <div class="col-md-2 step-one">
                          <Field
                            isFormGroup={true}
                            inputType="select"
                            inputName="status"
                            value={value.status}
                            options={STATUS}
                            index ={index}
                            label ={"Status "}
                            onChange={this.props.updateCosting}
                            disabled={this.state.disabled}
                          />
                      </div> */}
                    {/* <div class="col-md-2 step-one">
                      <Field
                          isFormGroup={true}
                          inputType="date"
                          inputName="completedDate"
                          label="Date Completed"
                          value={value.completedDate}
                          index ={index}
                          onChange={this.props.updateCosting}
                          disabled={this.state.disabled}
                        />
                      </div> */}
                    <div class="col-md-2 step-one mt-3">
                      <Button
                        onClick={e => this.props.viewCostingPage(e)}
                        buttonName={"View Costing"}
                      />
                    </div>
                    <div class="col-md-2 step-one mt-3">
                      <Button
                        onClick={e => this.props.createCostingPage(e)}
                        buttonName={"Create Costing"}
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-12 step-one">
                  <Field
                    isFormGroup={true}
                    inputType={"textarea"}
                    inputName={"costingComments"}
                    value={this.props.costingComments}
                    label={"comments"}
                    onChange={this.props.updateCosting}
                    disabled={this.state.disabled}
                  />
                </div>
              </div>
              {!this.state.disabled &&
                (permissions.create || permissions.edit) && (
                  <div class="col-md-12 no-padding text-center profile-btn">
                    <Button
                      onClick={e => this.props.createCosting(e)}
                      buttonName={"Save"}
                    />
                    <Button
                      onClick={e => this.props.completeCosting(e)}
                      buttonName={"Complete"}
                    />
                  </div>
                )}
            </form>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/CostingModule/index.js